export default "__VITE_ASSET__DI4iNTTT__"